import CONSTANTS from '../constants';
import NotificationService from '../services/NotificationService';

export function getNotifications() {
  return async (dispatch) => {
    try {
      let notifications = await NotificationService.getNotifications();
      if (notifications) {
        dispatch({ type: CONSTANTS.ACTIONS.NOTIFICATIONS.LIST, notifications });
      }
    } catch (error) {
      console.log('Error: ', error);
    }
  };
}
